// extracted by mini-css-extract-plugin
export var closeButton = "_20-0";